import { connect } from 'react-redux';
import Parameters from '../components/Parameters';
import { onChangeParameter } from '../actions/QuoteActions';

const mapStateToProps = state => (
  {
    parameters       : state.get('parameters').toJS(),
    quoteStep        : state.get('quote_step'),
    parametersChanged: state.get('parametersChanged'),
  }
);

export default connect(mapStateToProps, { onChangeParameter })(Parameters);
